import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusCircleIcon = _resolveComponent("PlusCircleIcon")!

  return (!_ctx.isHidden)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        title: "Add paper to a literature review search",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addToLitReview())),
        class: "add-paper-button"
      }, [
        _createVNode(_component_PlusCircleIcon, { class: "h-5 w-5 text-violet-500 inline" })
      ]))
    : _createCommentVNode("", true)
}